export const ENTERED_BY_MARKET_NAME = 'enteredByMarketName';
export const MALL_ID = 'mallId';
export const SITE_CODE = 'siteCode';
